import { render, staticRenderFns } from "./collectionListDialogBox.vue?vue&type=template&id=1be89482&scoped=true"
import script from "./collectionListDialogBox.vue?vue&type=script&lang=js"
export * from "./collectionListDialogBox.vue?vue&type=script&lang=js"
import style0 from "./collectionListDialogBox.vue?vue&type=style&index=0&id=1be89482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be89482",
  null
  
)

export default component.exports